import { render, staticRenderFns } from "./DialogChangePwd.vue?vue&type=template&id=f120bcec&scoped=true&"
import script from "./DialogChangePwd.vue?vue&type=script&lang=js&"
export * from "./DialogChangePwd.vue?vue&type=script&lang=js&"
import style0 from "./DialogChangePwd.vue?vue&type=style&index=0&id=f120bcec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f120bcec",
  null
  
)

export default component.exports